<template>
    <div class="automation-action-settings"></div>
</template>
<script>
export default {
    data: function () {
        return {
            title: this.t("automations-form-actions-auth_link-title"),
            description: this.t("automations-form-actions-auth_link-description"),
        };
    },
    mounted: function () {
        this.$emit("mounted", this);
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        changed: function () {
            this.$emit("input", {});
        },
        isValid: function () {
            return true;
        },
    },
};
</script>
